import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ChatMessage } from '../../../domain/messages/models/ChatMessage';
import { ProviderServices } from '../../../services/chat/createProviderServices';

export interface LoadChatMessagesHandlerInput {
	session: ChatSession;
	accessToken: string;
	providerServices: ProviderServices;
	skip?: number;
	count?: number;
}

export const loadChatMessagesHandler = async ({
	session,
	accessToken,
	providerServices,
	skip,
	count,
}: LoadChatMessagesHandlerInput): Promise<ChatMessage[]> => {
	// router to route based on provider type. This is used primarily for methods that are shared by all 3 apis.
	const selectedProviderServices = providerServices.providerServicesRouter.getProviderServices(
		session.providerType,
	);

	return selectedProviderServices.messages.getChatMessagesAsync(
		{
			chatId: session.id,
			skip,
			count,
		},
		accessToken,
	);
};

export default loadChatMessagesHandler;
